import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "relative z-10 flex flex-col items-center pt-[125px] md:pt-[177px]" }
const _hoisted_3 = { class: "relative w-full flex flex-col items-center overflow-hidden rounded-3xl" }
const _hoisted_4 = { class: "relative z-20 flex flex-col items-center py-0 px-4 md:py-10" }
const _hoisted_5 = { class: "h2 text-center mt-0 mb-2" }
const _hoisted_6 = ["innerHTML"]

import { computed } from 'vue';
import { Form } from 'vee-validate';
import { scrollToTop } from '../../helpers/scrollToTop';
import { useOnSubmit } from '../../hooks/useOnSubmit';
import AddToCartButton from './AddToCartButton.vue';
import ExternalErrorHinter from './ExternalErrorHinter.vue';
import { onMounted, onBeforeUnmount } from 'vue';


export default {
  __name: 'ProductForm',
  props: {
    imageSrc: String,
    schema: {
        type: Object,
        required: true,
    },
    initialValues: {
        type: Object,
        required: true,
    },
    checkoutlink: { type: String, required: true },
    id: {
        type: Number,
        required: true,
    },
    price: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    variations: {
        type: Array,
        required: false,
    },
    selectedVariation: {
        type: Number,
        required: false,
    },
    shortdescription: {
        type: String,
        required: true,  // Możesz to zmienić na false, jeśli ma być opcjonalne
    },
},
  setup(__props) {

const props = __props;

let isNavigatingBack = false;

onMounted(() => {
    history.pushState(null, null, document.URL);

    const handlePopState = (event) => {
        if (!isNavigatingBack) {
            const confirmation = window.confirm('Czy na pewno chcesz opuścić tę stronę?');
            if (confirmation) {
                isNavigatingBack = true;
                history.back();
            } else {
                history.pushState(null, null, document.URL);
            }
        }
    };

    window.addEventListener('popstate', handlePopState);

    onBeforeUnmount(() => {
        window.removeEventListener('popstate', handlePopState);
    });
});
const imageSrc =  window.config.images.topBackgroundCard;


const { onSubmit, isSubmitting, externalErrors } = useOnSubmit(props.id, props.checkoutlink);

const renderedPrice = computed(() => {
    if (!props.variations.length) return props.price;

    const price = props.variations?.find(
        (variation) => variation.variation_id === props.selectedVariation,
    ).display_price;

    return String(price);
});

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    "initial-values": __props.initialValues,
    "validation-schema": __props.schema,
    onInvalidSubmit: _unref(scrollToTop),
    enctype: "multipart/form-data",
    class: "erecepta-form",
    onSubmit: _cache[0] || (_cache[0] = (data) => _unref(onSubmit)(data, __props.selectedVariation)),
    onKeydown: _cache[1] || (_cache[1] = _withKeys($event => ($event.preventDefault()), ["enter"]))
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: "hidden lg:absolute lg:block lg:top-6 lg:right-6 lg:left-6 rounded-3xl lg:w-[calc(100%-3rem)]",
        src: _unref(imageSrc),
        alt: "Konsultacja medyczna online"
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(__props.title), 1),
            _createElementVNode("div", {
              class: "text-[16px] lg:text-xl leading-[26px] lg:leading-8 lg:max-w-[520px] text-center text-greyScale-600 font-normal md:max-w-[380px]",
              innerHTML: __props.shortdescription
            }, null, 8, _hoisted_6),
            _createVNode(ExternalErrorHinter, { externalErrors: _unref(externalErrors) }, null, 8, ["externalErrors"]),
            _renderSlot(_ctx.$slots, "default"),
            _createVNode(AddToCartButton, {
              title: __props.title,
              price: _unref(renderedPrice),
              isSubmitting: _unref(isSubmitting)
            }, null, 8, ["title", "price", "isSubmitting"])
          ])
        ])
      ])
    ]),
    _: 3
  }, 8, ["initial-values", "validation-schema", "onInvalidSubmit"]))
}
}

}